// Home.js
import React, { useEffect, useState } from "react";
import Header from "./common/Header";
import Card from "./common/Card";
import apiCall from "./common/Utils/helper";
import Masonry from 'react-masonry-css';
import SharePopup from "./Components/SharePopup";

const Home = () => {
  const [folderData, setFolderData] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [popupId, setPopupId] = useState(null);
  const [popupFolderName, setPopupFolderName] = useState("");

  useEffect(() => {
    const fetchFolderData = async () => {
      try {
        const result = await apiCall("get", "/getdistinctfolder");
        if (result.resultFlag === 1) {
          setFolderData(result.response.folderNames);
        } else {
          console.error("Failed to retrieve folder data:", result.message);
        }
      } catch (error) {
        console.error("Error fetching folder data:", error);
      }
    };

    fetchFolderData();
  }, []);

  const togglePopup = (id, folderName) => {
    setShowPopup(!showPopup);
    setPopupId(id);
    setPopupFolderName(folderName); 
  };

  const handleClosePopup = () => {
    setShowPopup(false);
  };

  const breakpointColumnsObj = {
    default: 4,
    1100: 3,
    700: 2,
    600: 1
  };

  return (
    <>
      {showPopup && <SharePopup onClose={handleClosePopup} id={popupId} folderName={popupFolderName} />} 
      <Header />
      <div className="list_section">
        <div className="photonav_container">
          <Masonry
            breakpointCols={breakpointColumnsObj}
            className="my-masonry-grid"
            columnClassName="my-masonry-grid_column">
              
            {folderData.map((folderDataItem, index) => (
              <Card
                key={index}
                folderName={folderDataItem.folder_name}
                assetDate={folderDataItem.asset_date}
                folderPaths={folderDataItem.file_paths}
                folderId={folderDataItem.folder_id}
                togglePopup={togglePopup}
              />
            ))}
            
          </Masonry>
        </div>
      </div>
    </>
  );
};

export default Home;
